import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Input,
  Label,
  Form,
  FormGroup,
  FormFeedback
} from "reactstrap";
import { validateQuotation } from "../_validate";
import { Field, reduxForm, change, formValueSelector } from "redux-form";
import DatePicker from "react-datepicker";
import moment from "moment";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { normalizeHelper, formatHelper } from "../../../../../common/helpers";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

class FormQuotation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeItem: {
        price: null
      }
    };
    this.onSubmitQuotation = this.onSubmitQuotation.bind(this);
    this.renderInputField = this.renderInputField.bind(this);
    this.renderItemsField = this.renderItemsField.bind(this);
  }

  toggleModal(itemType) {
    this.props.toggleModal(itemType);
  }
  onSubmitQuotation(values) {
    this.props.onSubmitQuotation(values);
  }

  componentDidUpdate() {
    this.checkItemsChange();
    this.checkDiscountChange();
  }

  checkItemsChange() {
    const { selectedOffers, selectedProducts, selectedServices } = this.props;
    if (selectedOffers || selectedProducts || selectedServices) {
      let totalPrice = 0;
      selectedOffers.forEach(offer => {
        totalPrice += offer.total_price;
      });

      selectedProducts.forEach(product => {
        totalPrice += product.price;
      });

      selectedServices.forEach(service => {
        totalPrice += service.price;
      });
      this.props.changeValueForm("QuotationAddForm", "totalPrice", totalPrice);
    }
  }
  checkDiscountChange() {
    if (this.props.discount == null) {
      this.props.changeValueForm(
        "QuotationAddForm",
        "totalPriceDiscounted",
        this.props.totalPrice
      );
    } else {
      let totalPriceDiscounted =
        this.props.totalPrice * (1 - this.props.discount / 100);
      this.props.changeValueForm(
        "QuotationAddForm",
        "totalPriceDiscounted",
        formatHelper.toTwoDecimal(totalPriceDiscounted)
      );
    }
  }

  renderExpirationDatePicker({ input, meta: { touched, error } }) {
    const className =
      touched && error ? "form-control is-invalid" : "form-control";
    const hasError = touched && error ? true : false;
    return (
      <FormGroup row style={{ zIndex: 10 }}>
        <Col md="2">
          <Label>Fecha de Expiración:</Label>
        </Col>
        <Col>
          <DatePicker
            selected={
              input.value
                ? moment.utc(new Date(input.value), "DD/MM/YYYY")
                : null
            }
            onChange={input.onChange}
            className={className}
            dateFormat={'DD/MM/YYYY'}
            showYearDropdown
            showMonthDropdown
          />
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }

  renderInputField(field) {
    const {
      meta: { touched, error }
    } = field;
    const hasError = touched && error ? true : false;
    const labelClass = field.labelClass ? field.labelClass : "mt-1";

    return (
      <FormGroup row>
        <Col md="2">
          <Label className={labelClass}>{field.label}</Label>
        </Col>
        <Col>
          <Input {...field.input} invalid={hasError} type={field.type} />
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }
  renderStaticField(field) {
    const {
      meta: { touched, error }
    } = field;
    const hasError = touched && error ? true : false;
    const labelClass = field.labelClass ? field.labelClass : "mt-1";

    return (
      <FormGroup row>
        <Col md="2">
          <Label className={labelClass}>{field.label}</Label>
        </Col>
        <Col>
          <Input
            {...field.input}
            invalid={hasError}
            type={field.type}
            readOnly
          />
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }
  renderCustomersItems() {
    return this.props.customers.map(customer => {
      return (
        <option key={customer.value} value={customer.value}>
          {customer.label}
        </option>
      );
    });
  }
  renderStoresItems() {
    return this.props.stores.map(store => {
      return (
        <option key={store.value} value={store.value}>
          {store.label}
        </option>
      );
    });
  }

  renderTypeItems(type) {
    if (type == "customer") {
      return this.renderCustomersItems();
    } else if (type == "store") {
      return this.renderStoresItems();
    }
  }

  renderItemsField(field) {
    const {
      meta: { touched, error }
    } = field;
    const hasError = touched && error ? true : false;
    return (
      <FormGroup row>
        <Col md="2">
          <Label htmlFor="select">{field.label}</Label>
        </Col>
        <Col>
          <Input {...field.input} type="select" invalid={hasError}>
            <option key={0} value={0}>
              Seleccione...
            </option>
            {this.renderTypeItems(field.input.name)}
          </Input>
          {hasError == true ? <FormFeedback>{error}</FormFeedback> : null}
        </Col>
      </FormGroup>
    );
  }
  render() {
    const { handleSubmit, modalOpen, isLoading } = this.props;
    const isLoadingSubmit = modalOpen || isLoading;

    return (
      <Form onSubmit={handleSubmit(handleSubmit(this.onSubmitQuotation))}>
        <Field name="code" label="Código:" component={this.renderStaticField} />
        <Field
          name="customer"
          label="Cliente:"
          component={this.renderItemsField}
        />
        <Field name="store" label="Tienda:" component={this.renderItemsField} />
        <Field
          name="expirationDate"
          label="Fecha Expiración:"
          type="text"
          component={this.renderExpirationDatePicker}
        />
        <Field
          name="totalPrice"
          label="Total (S/):"
          component={this.renderStaticField}
        />
        <Field
          name="discount"
          label="Descuento (%):"
          component={this.renderInputField}
          normalize={normalizeHelper.decimalOnlyField(0, 100)}
        />
        <Field
          name="totalPriceDiscounted"
          label="Total Descontado (S/):"
          component={this.renderStaticField}
        />
        <Row>
          <Col className="mt-3">
            <Button
              onClick={() => this.toggleModal("Productos")}
              disabled={isLoadingSubmit}
              color="primary"
              className="mr-1 mt-1"
            >
              <i className="icon-layers" /> Añadir Producto
            </Button>
            <Button
              onClick={() => this.toggleModal("Servicios")}
              disabled={isLoadingSubmit}
              color="primary"
              className="mr-1 mt-1"
            >
              <i className="icon-tag" /> Añadir Servicio
            </Button>
            <Button
              onClick={() => this.toggleModal("Ofertas")}
              disabled={isLoadingSubmit}
              color="primary"
              className="mr-1 mt-1"
            >
              <i className="icon-tag" /> Añadir Oferta
            </Button>
          </Col>
          <Col className="nav justify-content-end mt-3">
            <Button
              type="submit"
              disabled={isLoadingSubmit}
              color="primary"
              className="mr-2"
            >
              <i className="fa fa-save mr-1" /> Guardar
            </Button>
            <Button
              color="secondary"
              onClick={() =>
                this.props.history.push("/administration/quotations")
              }
            >
              <i className="fa fa-chevron-left mr-1" /> Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

FormQuotation.propTypes = {
  initialValues: PropTypes.object,
  customers: PropTypes.array,
  stores: PropTypes.array,
  selectedOffers: PropTypes.array,
  selectedServices: PropTypes.array,
  selectedProducts: PropTypes.array,
  onSubmitQuotation: PropTypes.func,
  toggleModal: PropTypes.func,
  itemType: PropTypes.string,
  modalOpen: PropTypes.bool,
  isLoading: PropTypes.bool
};
const formSelector = formValueSelector("QuotationAddForm");

function mapStateToProps(state) {
  return {
    totalPrice: formSelector(state, "totalPrice"),
    discount: formSelector(state, "discount")
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeValueForm: change
    },
    dispatch
  );
}

export default reduxForm({
  form: "QuotationAddForm",
  touchOnBlur: false,
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
  validate: validateQuotation
})(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withRouter(FormQuotation))
);



// WEBPACK FOOTER //
// ./src/scenes/Administration/Quotation/QuotationEdit/Forms/FormQuotation.js